/**
 * Created by huijuan on 15/8/31.
 */
import { serialize } from './util'
//截取特定action用于统计分析
export default function AnalysisAfterMiddleware(store) {
	return next => action => {

		if(!window.iTalentPMS) return next(action);

		var type = action.type || '';
		var guid = action.guid || '';
		var url = action.url || '';
		var analysisData = action.analysisData || {};
		var isAjax = false;
		var originType = type

		if (action.method && action.method.toLocaleUpperCase() == "GET" && action.params) {
        	url = url + "?" + serialize(action.params);
      	}
		//url加域名
      	if (url && url.indexOf('http') === -1) {
        	url = location.protocol + "//" + location.host + url;
      	}
		if (action.payload && action.payload === 'Injection') {
			var last = type.indexOf("_")!= -1 ? type.match(/.*_/)[0].lastIndexOf("_") : "";
	        type = last ? type.slice(0, last) : type;
			window.iTalentPMS.addAjax && window.iTalentPMS.addAjax(type, 'end', url, null, guid, analysisData);
			isAjax = true;
		}
		window.iTalentPMS.setCurrent && window.iTalentPMS.setCurrent('Action', {
			type : originType,
			isAjax : isAjax
		})
		return next(action);
	}
}